{
    "Accessibility Menu": "Meniu de accesibilitate",
    "Reset settings": "Resetează setările",
    "Close": "Închide",
    "Content Adjustments": "Ajustări conținut",
    "Adjust Font Size": "Ajustează dimensiunea fontului",
    "Highlight Title": "Evidențiază titlul",
    "Highlight Links": "Evidențiază legăturile",
    "Readable Font": "Font lizibil",
    "Color Adjustments": "Ajustări de culoare",
    "Dark Contrast": "Contrast întunecat",
    "Light Contrast": "Contrast luminos",
    "High Contrast": "Contrast ridicat",
    "High Saturation": "Saturație ridicată",
    "Low Saturation": "Saturație redusă",
    "Monochrome": "Monocrom",
    "Protanopia": "Protanopie",
    "Deuteranopia": "Deuteranopie",
    "Tritanopia": "Tritanopie",
    "Visual & Navigation Aids": "Instrumente vizuale și de navigare",
    "Additional Tools": "Instrumente suplimentare",
    "Reading Guide": "Ghid de lectură",
    "Stop Animations": "Opriți animațiile",
    "Big Cursor": "Cursor mare",
    "Screen Reader": "Cititor de ecran",
    "Hide Images": "Ascunde imaginile",
    "Image Tooltips": "Sfaturi pentru imagini",
    "Page Structure": "Structura paginii",
    "Super Focus": "Super Focus",
    "Magnifier": "Lupă",
    "Increase Font Size": "Mărește dimensiunea fontului",
    "Decrease Font Size": "Micșorează dimensiunea fontului",
    "Letter Spacing": "Spațierea literelor",
    "Line Height": "Înălțimea liniei",
    "Font Weight": "Grosimea fontului",
    "Dyslexia Font": "Font pentru dislexie",
    "Language": "Limbă",
    "Open Accessibility Menu": "Deschideți meniul de accesibilitate",
    "Accessibility Profiles": "Profiluri de accesibilitate",
    "Seizure Safe Profile": "Profil sigur pentru crize",
    "Stops animations and reduces color saturation.": "Oprește animațiile și reduce saturația culorilor.",
    "Blind Profile": "Profil pentru nevăzători",
    "Activates the screen reader for auditory navigation.": "Activează cititorul de ecran pentru navigare auditivă.",
    "Visually Impaired Profile": "Profil pentru persoane cu deficiențe vizuale",
    "Enhances contrast and readability for low vision.": "Îmbunătățește contrastul și lizibilitatea pentru vedere slabă.",
    "ADHD Friendly Profile": "Profil pentru ADHD",
    "Reduces distractions for better focus.": "Reduce distragerile pentru o mai bună concentrare.",
    "Cognitive & Learning Profile": "Profil cognitiv și de învățare",
    "Helpful tools for reading and comprehension.": "Instrumente utile pentru citire și înțelegere.",
    "Motor Impaired Profile": "Profil pentru dizabilități motorii",
    "Optimizes the site for keyboard-only navigation.": "Optimizează site-ul pentru navigare exclusiv cu tastatura.",
    "Headings": "Titluri",
    "Landmarks": "Repere",
    "Links": "Legăuri",
    "Focus element": "Focusează elementul",
    "Visit link": "Vizitează legătura"
}